import * as React from 'react';
import moment from 'moment';

import { connect } from 'react-redux';

import { ICalendarAppState } from '../../redux-state';
import GridMonthContainerView from './grid-month-container.view';
import { CalendarDeviceMode, CalendarViewMode } from '../../redux-state/interfaces/calendar-settings';

interface IGridMonthContainerExternalProps {

}

interface StateToProps {
    currentMoment: moment.Moment;
    calendarViewMode: CalendarViewMode;
    calendarDeviceMode: CalendarDeviceMode;
}

export type GridMonthContainerProps = IGridMonthContainerExternalProps & StateToProps;

export class GridMonthContainerBase extends React.Component<GridMonthContainerProps, any> {
    render() {
        return (
            <GridMonthContainerView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IGridMonthContainerExternalProps): StateToProps {
    return {
        currentMoment: state.calendar.currentDate,
        calendarViewMode: state.calendarSettings.calendarViewMode,
        calendarDeviceMode: state.calendarSettings.calendarDeviceMode
    }
}

export default connect<StateToProps>(mapStateToProps)(GridMonthContainerBase);

